export const isValidLink = (value: string): boolean => {
  const linkRegexPattern = /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\\/~+#-]*[\w@?^=%&\\/~+#-])$/i;

  return new RegExp(linkRegexPattern).test(value);
};
